import { useEffect, useState } from 'react'
import contentService from '../../services/contentService'

/**
 * Dynamically updates document <head> meta tags from the content API.
 * Falls back to whatever is already in index.html.
 */
const SeoHead = () => {
  const [applied, setApplied] = useState(false)

  useEffect(() => {
    if (applied) return
    contentService.getByType('seo')
      .then(({ data }) => {
        if (!data) return
        if (data.title) document.title = data.title
        const setMeta = (attr, key, value) => {
          const el = document.querySelector(`meta[${attr}="${key}"]`)
          if (el && value) el.setAttribute('content', value)
        }
        setMeta('name', 'description', data.description)
        setMeta('name', 'keywords', data.keywords)
        setMeta('name', 'author', data.author)
        setMeta('property', 'og:title', data.title)
        setMeta('property', 'og:description', data.description)
        setMeta('property', 'og:url', data.canonicalUrl)
        setMeta('name', 'twitter:title', data.title)
        setMeta('name', 'twitter:description', data.description)
        if (data.canonicalUrl) {
          const canonical = document.querySelector('link[rel="canonical"]')
          if (canonical) canonical.setAttribute('href', data.canonicalUrl)
        }
        setApplied(true)
      })
      .catch(() => {})
  }, [applied])

  return null
}

export default SeoHead
